export const NavigationMenuIdentifiers = {
  POS: 'pos',
  MARKETS: 'markets',
  FAMILIES: 'families',
  HOTEL_FAMILIES: 'hotel-families',
  AIR_FAMILIES: 'air-families',
  FARES: 'fares',
  FLIGHTS: 'flights',
  HOTELS: 'hotels'
};

export type NavigationMenuIdentifier = (typeof NavigationMenuIdentifiers)[keyof typeof NavigationMenuIdentifiers];

export const NavigationMenuTitles = {
  POS: 'Points Of Sale',
  MARKETS: 'Markets',
  FAMILIES: 'Families',
  HOTEL_FAMILIES: 'Hotel Families',
  AIR_FAMILIES: 'Air Families',
  FARES: 'Dynamic Exclusions',
  FLIGHTS: 'Flights',
  HOTELS: 'Hotels'
};
